import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IFileWithMeta } from "react-dropzone-uploader";
import {
  UpfrontPaymentInputTitle,
  UpfrontPaymentInputWrapper,
} from "../UpfrontPayment.styles";
import { FileDropzoneUploader } from "../FileDropzoneUploader/FileDropzoneUploader";
import { StyledInputOptional } from "../../shared/UI-Library/UI-Library.styles";

interface DocumentUploaderProps {
  selectedFile: IFileWithMeta | null;
  setSelectedFile: React.Dispatch<React.SetStateAction<IFileWithMeta | null>>;
}

export const StepDocumentUploader: React.FC<DocumentUploaderProps> = ({
  selectedFile,
  setSelectedFile,
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);
  const [initialFiles] = useState<File[]>(() =>
    selectedFile ? [selectedFile.file] : [],
  );

  const [files, setFilesInternal] = useState<IFileWithMeta[]>([]);

  useEffect(() => {
    setSelectedFile(files.length > 0 ? files[0] : null);
  }, [files, setSelectedFile]);

  return (
    <>
      <UpfrontPaymentInputTitle>
        {t("upfrontPayment.financialAssistance.documentUploadTitle")}{" "}
        <StyledInputOptional>
          {t("upfrontPayment.stripe.optional")}
        </StyledInputOptional>
      </UpfrontPaymentInputTitle>
      <UpfrontPaymentInputWrapper>
        <FileDropzoneUploader
          files={files}
          setFiles={setFilesInternal}
          error={error}
          setError={setError}
          initialFiles={initialFiles}
          maxFiles={1}
          multiple={false}
        />
      </UpfrontPaymentInputWrapper>
    </>
  );
};
